import watermark from "./watermark";

const install = function (Vue) {
    Vue.directive("watermark", watermark);
};
export default install;
